var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#FFCD00",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    color: "#FFCD00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "soundsIconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7L12 17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10L15 14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8L18 16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13L21 11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L9 20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L6 15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13L3 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSounds);
export default __webpack_public_path__ + "static/media/sounds.e56eadc5c4513d512a3bbeb001d71401.svg";
export { ForwardRef as ReactComponent };